import React from 'react';
import Popup from '../../Popup';
import SchoolSearch from '../../Form/SchoolSearch';

const CompareTeamPopUp = ({ clubId, clubSubType, type, onCloseClick }) => {
    const title = 'Find team to compare';
    const isCollegeType = type === 'college';
    const placeholder = isCollegeType ? `Search for college by name` : `Search for high school by name`;
    const endPoint = isCollegeType ? '/colleges' : '/highSchools';
    const filter = `clubSubTypeId:${clubSubType.id}`;

    const handleOnSchoolClubSelect = (schoolClub) => {
        onCloseClick();
        window.location.href = `/schools/teamcompare?team1=${clubId}&team2=${schoolClub.id}`;
    };

    return (
        <Popup
            className="popup-sm clear-over-flow"
            onCloseClick={onCloseClick}
            config={{
                fullScreen: true,
                noPadding: true,
                scrollable: true,
                style: { height: 'auto' },
            }}
        >
            <div className="popup-section p24 pt0">
                <h5>{title}</h5>
            </div>
            <div className="popup-section p24 pt0">
                <SchoolSearch
                    placeholder={placeholder}
                    handleSchoolSelect={handleOnSchoolClubSelect}
                    clearAfterSelect={true}
                    searchEndPoint={endPoint}
                    filter={filter}
                    schoolClubSearch={true}
                />
            </div>
        </Popup>
    );
};

export default CompareTeamPopUp;
